import Vue from "vue";
import GSignInButton from "vue-google-signin-button";

Vue.use(GSignInButton);
